/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DeepAnalysisControllerCancelMutationResponse, DeepAnalysisControllerCancelPathParams, DeepAnalysisControllerCancel400, DeepAnalysisControllerCancel401, DeepAnalysisControllerCancel403, DeepAnalysisControllerCancel404 } from "../../models/aiAgentV2Controller/DeepAnalysisControllerCancel";

function getDeepAnalysisControllerCancelUrl(sessionId: DeepAnalysisControllerCancelPathParams["sessionId"]) {
  const res = { method: 'DELETE', url: `/api/v1/ai-agent-v2/deep-analysis/${sessionId}` as const }  
  return res
}

/**
 * @summary Cancel deep analysis session
 * {@link /api/v1/ai-agent-v2/deep-analysis/:sessionId}
 */
export async function deepAnalysisControllerCancel(sessionId: DeepAnalysisControllerCancelPathParams["sessionId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeepAnalysisControllerCancelMutationResponse, ResponseErrorConfig<DeepAnalysisControllerCancel400 | DeepAnalysisControllerCancel401 | DeepAnalysisControllerCancel403 | DeepAnalysisControllerCancel404>, unknown>({ method : "DELETE", url : getDeepAnalysisControllerCancelUrl(sessionId).url.toString(), ... requestConfig })  
  return res.data
}